import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { ViewModalComponent } from '@scaffold/dialogs/view-modal/view-modal.component';
import { ScaffoldDialogService, ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { RenderedService } from '@scaffold/view/rendered/rendered.service';
import { CourseService } from '@scaffold/services/course.service';
import { TranslationService } from '@services/translation.service';
import { Subscription } from 'rxjs';

interface SearchData {
  key?: string,
  term?: string;
  itemState?:string
}

@Component({
  selector: 'app-gradebook',
  templateUrl: './gradebook.component.html',
  styleUrls: ['./gradebook.component.scss']
})

export class GradebookComponent extends BaseScaffoldComponent implements OnInit {
  private _filter;
  isLoading: boolean;
  set filter(fil) {
    this._filter = fil;
  }
  get filter() {
    return this._filter;
  }
  set active(page) {
    this._active = page;
    this.loadGradebook(this.perPage, this.active - 1);
  }
  get active() {
    return this._active;
  }

  get hasFilters(){
    return this.filter||this.searchData?.term;
  }
  perPage = 10;
  private _active = 1;
  itemCount: number;
  dialogRef: ScaffoldDialogRef;
  showDroppedStudents = false;
  _listObservable: Subscription;
  searchData: SearchData = {

  };
  public directionAsc:boolean = true;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    public dialog: ScaffoldDialogService,
    private courseService: CourseService,
    private translationService:TranslationService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit(): void {
    this.itemCount = this.item?.data?.studentCount;
    this.perPage = this.item?.pageCounts[0]?.count || 10;
    console.log(this.item);
  }

  openViewHandler(type: string, id: number | string) {
    const settings: any = {
      context: {
        data: {
          mode: 'read',
          item: { id, type },
        },
      },
    };
    this.dialogRef = this.dialog.open(ViewModalComponent, settings);
    this.dialogRef.onClose.subscribe((result) => {
      console.log(result);
      console.log(this.item);
      console.log(this.info);
      if (result && (result !== 'string' || result.length > 0)) {
        if (this.item && this.item.list_view) {
        }
      }
    });
  }

  perPageChange(e){
    this.perPage = e;
    this.active = 1
    this.update();    
  }

  getCountLabel() {
    const students = this.translationService.getTranslatedContent('students','Students')
    const of  =  this.translationService.getTranslatedContent('of','of')
    if(!this.itemCount)return''
    let label = '';
    const start = this.active * this.perPage - this.perPage + 1;
    const end = Math.min(
      this.active * this.perPage,
      this.itemCount
    );
    label = `${start} - ${end} ${of} ${this.itemCount} ${students}`;
    if (this.itemCount && this.perPage > this.itemCount) {
      label = `${this.itemCount} ${students}`;
    }
    return label;
  }

  filteredAssignments(list) {
    if (!this.filter || this.filter === '') {
      return list;
    }
    let reg = new RegExp(this.filter, 'i');
    return list.filter(i => i.data.name.match(reg));
  }

  search(event) {
    this.searchData = event;
    this.loadGradebook(this.perPage, this.active - 1);
  }



  loadGradebook(count?: number, page?: number) {
    if (this._listObservable) {
      this._listObservable.unsubscribe();
    }
    this.isLoading = true
    let url = this.info.type + "/" + this.info.id + `/load_grade_book?direction=${this.directionAsc?'ASC':'DESC'}`;
    if (count) {
      url += `&perPage=${count}`;
    }
    if (count) {
      url += `&pageNumber=${page}`;
    }
    if (
      this.searchData.itemState
    ) {
      url += `&state=${this.searchData.itemState}`;
    }
    if (this.searchData.key && this.searchData.term) {
      url +=
        '&searchParam=' +
        this.searchData.key +
        '&searchTerm=' +
        encodeURIComponent(this.searchData.term);
    }
    // this.item.data.assignments = [];
    // this.item.data.students = [];
    // this.update();
    this._listObservable =
    this.courseService.get(url).subscribe((co) => {
      this.item.data.assignments = co.assignments;
      this.item.data.students = co.students;
      this.itemCount = co.studentCount;
      this.update();
      this.isLoading = false;
    });

    // function getPlaceholder(): void {
    //   let el = document.getElementById('srchbx');
    //   console.log(el.ariaPlaceholder);
    //   el.setAttribute("ariaPlaceholder", "search gradebook" );
    //   console.log(el);
    // }
  }

  processScoreDisplay(entry, column) {

    if (!entry?.hasOwnProperty('score')&& entry.scale_type !=='CompleteIncomplete'){
      const noGradeContent = this.translationService.getTranslatedContent('no_grade','No Grade')
      return `<span class='TablesTable-Data-inactive'>${noGradeContent}</span>`;}
    if (entry.exempt === true || entry.exempt === 'true' ) {
      const exemptContent = this.translationService.getTranslatedContent('exempt','Exempt')
      return `<span class='TablesTable-Data-inactive'>${exemptContent}</span>`;
    }
    let display = '';
    switch (entry.scale_type) {
      case "Percent":
        let score = entry.score.replace(/%/, '%');
        if (isNaN(entry.score)) {
          display = score;
        } else {
          display = `${score}%`;
        }
        break;
      case "Text":
        display = entry.score;
        break;
      case "Tabular":
        display = entry.score;
        break;
      case "CompleteIncomplete":
        if (entry.score) {
          display = `<span class="TablesTable-Data-inactive">Complete - Score:${entry.score}</span>`;
        } else {
          display = '<span class="TablesTable-Data-inactive">Complete</span>';
        }
        const completeContent = this.translationService.getTranslatedContent('complete','Complete')
        const incompleteContent = this.translationService.getTranslatedContent('incomplete','Incomplete')

        display = `<span class="TablesTable-Data-inactive">${entry.score ? completeContent : incompleteContent}</span>`;
        break;
      case "Score":
        if (isNaN(entry.score)) {
          display = entry.score;
        } else {
          display = `${entry.score}/${column.points_possible}`;
        }
        break;
      default:
        if (isNaN(entry.score)) {
          display = entry.score;
        } else {
          display = `${entry.score}/${column.points_possible}`;
        }
        break;
    }
    if (entry.score_text || entry.scoreText) {
      display += ` (${entry.score_text || entry.scoreText})`;
    }
    return display;
  }

  sortByLastName() {
    this.directionAsc = !this.directionAsc
    this.loadGradebook(this.perPage, this.active - 1);
  }

  checkVisible(column){
    let visible = true;
    if(column.data.hasOwnProperty('visible')){
      console.log('visible found:', column);
      visible = column.data.visible;
    }
    return visible;
  }

}
